module.exports = __webpack_public_path__ + "media/video-bg.e0d686bb.mp4";